import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Trash2, EyeOff, Star } from "lucide-react";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function AdminContent() {
  const [tab, setTab] = useState("debates");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get(`/admin/${tab}`).then((r) => setItems(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, [tab]);

  const del = async (id) => {
    if (!window.confirm("Delete this content?")) return;
    try { await api.delete(`/admin/${tab}/${id}`); toast.success("Deleted"); load(); }
    catch { toast.error("Failed"); }
  };
  const hide = async (id) => {
    try { await api.post(`/admin/${tab}/${id}/hide`); toast.success("Toggled visibility"); load(); }
    catch { toast.error("Failed"); }
  };
  const feature = async (id) => {
    try { await api.post(`/admin/debates/${id}/feature`); toast.success("Feature toggled"); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="p-6 lg:p-10">
      <div className="border-b border-border pb-6 mb-8">
        <div className="label-mono text-muted-foreground mb-1">Moderation</div>
        <h1 className="font-serif text-4xl mb-6">Content</h1>
        <div className="border border-border inline-flex">
          {["debates", "thoughts", "groups"].map((k) => (
            <button
              key={k}
              onClick={() => setTab(k)}
              data-testid={`admin-content-tab-${k}`}
              className={`label-mono px-5 py-2.5 transition-colors ${tab === k ? "bg-foreground text-background" : "text-muted-foreground hover:bg-secondary"}`}
            >
              {k}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="label-mono text-muted-foreground">Loading…</div>
      ) : items.length === 0 ? (
        <div className="border border-dashed border-border p-16 text-center label-mono text-muted-foreground">
          No {tab} yet
        </div>
      ) : (
        <div className="border border-border divide-y divide-border">
          {items.map((it) => (
            <div key={it.id} className="p-4 flex items-center gap-4 flex-wrap hover:bg-secondary/40" data-testid={`admin-content-${it.id}`}>
              <div className="flex-1 min-w-0">
                {tab === "groups" ? (
                  <>
                    <Link to={`/groups/${it.id}`} className="text-sm hover:underline">{it.name}</Link>
                    <div className="label-mono text-muted-foreground">{it.members_count} members</div>
                  </>
                ) : (
                  <>
                    <Link to={tab === "debates" ? `/debates/${it.id}` : `/thoughts`} className="text-sm hover:underline line-clamp-1">
                      {it.title}
                    </Link>
                    <div className="label-mono text-muted-foreground">
                      @{it.author?.username} · {it.views} views · {it.hidden ? "hidden" : "visible"} {it.featured ? " · featured" : ""}
                    </div>
                  </>
                )}
              </div>
              <div className="flex gap-2">
                {tab === "debates" && (
                  <Button size="sm" variant="outline" className="rounded-sm h-8" onClick={() => feature(it.id)} data-testid={`feature-${it.id}`}>
                    <Star className="w-3 h-3" />
                  </Button>
                )}
                {tab !== "groups" && (
                  <Button size="sm" variant="outline" className="rounded-sm h-8" onClick={() => hide(it.id)} data-testid={`hide-${it.id}`}>
                    <EyeOff className="w-3 h-3" />
                  </Button>
                )}
                <Button size="sm" variant="outline" className="rounded-sm h-8 hover:bg-[hsl(var(--oppose))] hover:text-white" onClick={() => del(it.id)} data-testid={`delete-${it.id}`}>
                  <Trash2 className="w-3 h-3" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
